import { zodResolver } from "@hookform/resolvers/zod";
import { FieldValues, FormProvider, useForm } from "react-hook-form";
import { z } from "zod";
import { FormProps, UseZodFormProps } from "./Form.types";
import { FormInput } from "./Input";
import { FormRadioGroup } from "./RadioGroup";
import { FormSelect } from "./Select";
import { FormCheckboxGroup } from "./CheckboxGroup";
import { FormTimePicker } from "./Timepicker";
import { FormDatePicker } from "./Datepicker";
import { FormCheckbox } from "./Checkbox";
import { FormLocationAutoComplete } from "./LocationAutoComplete";
import { FormTextArea } from "./TextArea";
import { FormRangePicker } from "./RangePicker";
import { FormSwitch } from "./Switch";
import { FormMultiDatePickerCalendar } from "./FormMultiDatePickerCalendar/FormMultiDatePickerCalendar";

export function Form<T extends FieldValues>({
  form,
  form: { handleSubmit },
  onSubmit,
  onSubmitError,
  children,
  noValidate = true,
  ...props
}: FormProps<T>) {
  return (
    <FormProvider {...form}>
      <form onSubmit={handleSubmit(onSubmit, onSubmitError)} noValidate={noValidate} {...props}>
        {children}
      </form>
    </FormProvider>
  );
}

Form.TextArea = FormTextArea;
Form.Input = FormInput;
Form.RadioGroup = FormRadioGroup;
Form.CheckboxGroup = FormCheckboxGroup;
Form.Checkbox = FormCheckbox;
Form.Select = FormSelect;
Form.DatePicker = FormDatePicker;
Form.TimePicker = FormTimePicker;
Form.LocationAutoComplete = FormLocationAutoComplete;
Form.RangePicker = FormRangePicker;
Form.Switch = FormSwitch;
Form.MultiDatePickerCalendar = FormMultiDatePickerCalendar;

export const useSchemaForm = <S extends z.ZodSchema>({
  schema,
  ...formProps
}: UseZodFormProps<S>) =>
  useForm({
    ...formProps,
    resolver: zodResolver(schema),
  });
